import { Stack } from '@factorialco/f0-react/dist/experimental'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import DescriptionField from './DescriptionField'
import InternalReferenceField from './InternalReferenceField'

interface Props extends PermissionsProps, CustomizationProps {}

const AdditionalInformation = (props: Props) => {
  return (
    <Stack gap="6">
      <DescriptionField {...props} fieldIdentifier="description" />
      <InternalReferenceField {...props} fieldIdentifier="internal_reference" />
    </Stack>
  )
}

export default AdditionalInformation
